import React, { Fragment } from 'react'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { AppraisalFormProps } from '../../Interface/EmployeeManager/AppraisalForm/AppraisalForm'
interface ApTextareaProps {
  name: string
  index: number
  register: UseFormRegister<any> // Replace `any` with your form's data type
  errors?: FieldErrors<AppraisalFormProps>
  rules?: object
  disable?: boolean
}

const ApSelectWeight: React.FC<ApTextareaProps> = ({
  name,
  index,
  register,
  errors,
  rules,
  disable,
}) => {
  // console.log('KPI ERROR', { errors })
  // console.log('KPI ERROR', {
  //   errors: errors?.kpi && errors.kpi[0]?.manager_score?.message,
  // })
  return (
    <Fragment>
      <select
        {...register(name, rules)}
        className={`second-child form-control ap-select kpi-input-select h-100 ${
          errors && errors.kpi && errors.kpi[index]?.relevance ? 'is-invalid' : ''
        }`}
        disabled={disable}
      >
        <option value={''}>-</option>
        <option value={5}>5</option>
        <option value={10}>10</option>
        <option value={20}>20</option>
        <option value={30}>30</option>
        <option value={40}>40</option>
        <option value={50}>50</option>
        <option value={60}>60</option>
        <option value={70}>70</option>
        <option value={80}>80</option>
        <option value={90}>90</option>
        <option value={100}>100</option>
      </select>
      {errors && errors.kpi && (
        <div className='invalid-feedback'>{errors.kpi[index]?.employee_score?.message}</div>
      )}
      {errors && errors.kpi && (
        <div className='invalid-feedback'>{errors.kpi[index]?.manager_score?.message}</div>
      )}
    </Fragment>
  )
}

export default ApSelectWeight
